export default __webpack_public_path__ + "static/media/Vysehrad.d853087c.jpg";